import { ResumeExample } from "@/pages/Examples/ResumeExample";
import { Resume } from "@/types";

interface ResumePreviewGridProps {
    resumes: Array<Resume>;
    selectedResumeIds: string[];
    setSelectedResumeIds: (ids: string[]) => void;
    multipleSelect?: boolean;
}

const ResumePreviewGrid = ({
    resumes,
    selectedResumeIds,
    setSelectedResumeIds,
    multipleSelect = false,
}: ResumePreviewGridProps) => {
    return (
        <ul
            role="list"
            className="create-resume-grid grid justify-center gap-6 pb-6 pt-1"
        >
            {resumes?.map(resume => (
                <ResumeExample
                    key={resume.id}
                    resume={resume}
                    onSelect={() => {
                        if (multipleSelect) {
                            if (selectedResumeIds.includes(resume.id)) {
                                setSelectedResumeIds(
                                    selectedResumeIds.filter(
                                        id => id !== resume.id,
                                    ),
                                );
                            } else {
                                setSelectedResumeIds([
                                    ...selectedResumeIds,
                                    resume.id,
                                ]);
                            }
                        } else {
                            setSelectedResumeIds([resume.id]);
                        }
                    }}
                    isSelected={selectedResumeIds.includes(resume.id)}
                />
            ))}
            <li className="h-3"></li>
            <li className="h-3"></li>
            <li className="h-3"></li>
        </ul>
    );
};

export default ResumePreviewGrid;
